<div class="item-list-component">
  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
    <dx-button *ngIf="lotInPreparationProperties"
               hint="{{ 'SHARED.MOVE_UP' | translate }}"
               icon="arrowup"
               (onClick)="moveUp($event)">
    </dx-button>
    <dx-button *ngIf="lotInPreparationProperties"
               hint="{{ 'SHARED.MOVE_DOWN' | translate }}"
               icon="arrowdown"
               (onClick)="moveDown($event)">
    </dx-button>
  </div>

  <dx-data-grid id="printSection"
                [dataSource]="items"
                [showBorders]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="editItem($event)">
    <dxo-sorting [mode]="lotInPreparationProperties ? 'none' : 'single'"></dxo-sorting>
    <dxo-filter-row [visible]="!lotInPreparationProperties"></dxo-filter-row>
    <dxo-filter-panel [visible]="!lotInPreparationProperties"></dxo-filter-panel>
    <dxo-header-filter [visible]="!lotInPreparationProperties"></dxo-header-filter>
    <dxo-paging [pageSize]="pageSize"></dxo-paging>
    <dxo-pager [visible]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showNavigationButtons]="true"
               [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>

    <dxi-column [visible]="lotInPreparationProperties"
                [allowFiltering]="false"
                [allowHeaderFiltering]="false"
                [width]="45"
                cellTemplate="selectionTemplate">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="string"
                caption="{{ 'SHARED.NAME' | translate }}"
                [calculateCellValue]="getName">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="string"
                dataField="productPropertyName"
                caption="{{ 'PRODUCT.PROPERTY_NAME' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="string"
                dataField="productPropertyTypeName"
                caption="{{ 'SHARED.TYPE' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="string"
                caption="{{ 'PRODUCT.PROPERTY.MASTER_DATA_FIELD_NAME' | translate }}"
                [calculateCellValue]="getMasterDataFieldName">
    </dxi-column>
    <dxi-column [visible]="!lotInPreparationProperties"
                [editorOptions]="{ showClearButton: true }"
                dataType="number"
                dataField="columnNumber"
                caption="{{ 'PRODUCT.PROPERTY.COLUMN_NUMBER' | translate }}">
    </dxi-column>
    <dxi-column [visible]="!lotInPreparationProperties"
                [editorOptions]="{ showClearButton: true }"
                dataType="number"
                dataField="rowNumber"
                caption="{{ 'PRODUCT.PROPERTY.ROW_NUMBER' | translate }}">
    </dxi-column>
    <dxi-column [visible]="!lotInPreparationProperties"
                [editorOptions]="{ showClearButton: true }"
                dataType="number"
                dataField="width"
                caption="{{ 'PRODUCT.PROPERTY.WIDTH_PERCENTAGE' | translate }}">
    </dxi-column>
    <dxi-column [visible]="lotInPreparationProperties"
                [editorOptions]="{ showClearButton: true }"
                dataType="string"
                dataField="productPropertyEditorSelectionDetails.shortkeyLabel"
                caption="{{ 'PRODUCT.PROPERTY.SHORTKEY_LABEL' | translate }}">
    </dxi-column>
    <dxi-column type="buttons" [width]="70">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="editItem"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
    </dxi-column>

    <div *dxTemplate="let cell of 'selectionTemplate'" (click)="$event.stopPropagation()">
      <dx-check-box [(value)]="cell.data.selected"></dx-check-box>
    </div>
  </dx-data-grid>
</div>

<current-lot-property-component
[propertyGroupingShowing]="propertyGroupingShowing"
[automaticProductPropertyNonGroupingSelections]="automaticProductPropertyNonGroupingSelections"
[manualProductPropertyNonGroupingSelections]="manualProductPropertyNonGroupingSelections"
(onAdded)="onProductPropertyAdded($event)" (onUpdated)="onProductPropertyUpdated($event)" [showWidth]="showWidth"
[lotInPreparationProperties]="lotInPreparationProperties" [showConfigStyling]="showConfigStyling"></current-lot-property-component>
